
import { mapState } from 'vuex';

export default {
  name: 'ReviewPolicyDialog',
  data() {
    return {
      isLoading: true,
      reviewPolicy: {}
    };
  },
  computed: {
    ...mapState('window', ['windowService']),
    ...mapState(['api'])
  },
  created() {
    this.loadReviewPolicy();
  },
  methods: {
    async loadReviewPolicy() {
      this.isLoading = true;
      try {
        const { data } = await this.api.fetchReviewPolicy();
        this.reviewPolicy = data;
      } finally {
        this.isLoading = false;
      }
    },
    isNumberedContent(content) {
      return /^\d+\./.test(content);
    },
    close() {
      this.windowService.closeFullscreenPopup();
    }
  }
};
